module.exports = __webpack_public_path__ + "img/fund_logo.221675e0.png";